import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/manager")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to="/" />;
}
